import React, { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import AccountNavigation from '../Navigation/AccountNavigation';
import { Col, FormLabel, Row, Stack } from 'react-bootstrap';
import EditProfileImg from '../../../../assets/images/svg/edit-profile-img.svg'
import editIcon from '../../../../assets/images/svg/table-edit.svg';
import { useGetProfile } from '@hooks';
import { onDefaultError } from '../../../../helpers/commonHelpers';

const ViewEditProfile = ({ t }) => {
    const navigate = useNavigate();
    const [data, setData] = useState({});

    // Formik value set
    const { refetch, isLoading } = useGetProfile(
        ({ data: profile }) => {
            if (profile) {
                setData(profile);
            }
        },
        (error) => {
            onDefaultError(error);
        }
    );



    return (
        <div>
            {data && Object.keys(data).length > 0 ? (

                <>
                    <AccountNavigation t={t} formatted_joining_date={data?.formatted_joining_date} formatted_last_working_date={data?.formatted_last_working_date} data={data}/>
                    <Stack className='d-flex flex-row align-items-center gap-3 gap-md-4 px-4 my-4'>
                        <div className='my-profile-image'>
                            <img src={data?.profile_image}></img>
                        </div>
                        <div className='my-profile-username-wrapper'>
                            <h1>{data?.first_name + ' ' + data?.last_name}</h1>
                            <Link
                                to={'/edit-profile'}
                                className="table-button edit-btn">
                                <img src={`admin/${editIcon}`}></img> &nbsp;
                                {t('page.edit_profile_edit_profile_label')}
                            </Link>
                        </div>
                    </Stack>

                    <Row className='px-4'>
                        {/* Email */}
                        <Col md={4} xs={12} className='mb-3 mb-md-4'>
                            <FormLabel className='my-profile-label'>{t('page.edit_profile_email_label')}</FormLabel>
                            <div className='my-profile-value'>{data?.email}</div>
                        </Col>

                        {/* Contact Number */}
                        <Col md={4} xs={12} className='mb-3 mb-md-4'>
                            <FormLabel className='my-profile-label'>{t('page.edit_profile_contact_number_label')}</FormLabel>
                            <div className='my-profile-value'>+{data?.phone_code}  {data?.phone}</div>
                        </Col>

                        {data?.user_type == 2 && (
                            <Col md={4} xs={12} className='mb-3 mb-md-4'>
                                <FormLabel className='my-profile-label'>{t('page.edit_profile_hr_assigned_label')}</FormLabel>
                                <div className='my-profile-value'>{data?.assigned_hr_name != '' ? data?.assigned_hr_name : '-'}</div>
                            </Col>
                        )}

                        {/* Gender */}
                        <Col md={4} xs={12} className='mb-3 mb-md-4'>
                            <FormLabel className='my-profile-label'>{t('page.edit_profile_gender_label')}</FormLabel>
                            <div className='my-profile-value'>{data?.gender == 1 ? 'Male' : data?.gender == 2 ? 'Female' : data?.gender == 3 ? 'Other' : '-'}</div>
                        </Col>

                        {/* User Type */}
                        <Col md={4} xs={12} className='mb-3 mb-md-4'>
                            <FormLabel className='my-profile-label'>{t('page.edit_profile_user_type_label')}</FormLabel>
                            <div className='my-profile-value'>{data?.user_type == 1 ? 'Admin' : data?.user_type == 2 ? 'Employee' : data?.user_type == 3 ? 'Client' : '-'}</div>
                        </Col>

                        {/* User Role */}
                        <Col md={4} xs={12} className='mb-3 mb-md-4'>
                            <FormLabel className='my-profile-label'>{t('page.edit_profile_user_role_label')}</FormLabel>
                            <div className='my-profile-value'>{data?.role_name}</div>
                        </Col>

                        {/* User Status */}
                        <Col md={4} xs={12} className='mb-3 mb-md-4'>
                            <FormLabel className='my-profile-label'>{t('page.edit_profile_user_status_label')}</FormLabel>
                            <div className='my-profile-value'>{data?.user_status == 0 ? 'Inactive' : data?.user_status == 1 ? 'Active' : '-'}</div>
                        </Col>

                        {/* Created Date */}
                        <Col md={4} xs={12} className='mb-3 mb-md-4'>
                            <FormLabel className='my-profile-label'>{t('page.edit_profile_created_date_label')}</FormLabel>
                            <div className='my-profile-value'>{data?.formatted_created_at}</div>
                        </Col>

                        {data?.user_type == 2 && (
                            <Col md={4} xs={12} className='mb-3 mb-md-4'>
                                <FormLabel className='my-profile-label'>{t('page.edit_profile_branch_label')} </FormLabel>
                                <div className='my-profile-value'>{data?.branch_name != '' ? data?.branch_name : '-'}</div>
                            </Col>
                        )}

                        {data?.user_type == 2 && (
                            <Col md={4} xs={12} className='mb-3 mb-md-4'>
                                <FormLabel className='my-profile-label'>
                                    {t('page.edit_profile_last_appraisal_date_label')}
                                </FormLabel>
                                <div className='my-profile-value'>
                                    {data?.formatted_last_appraisal_date ?? '-'}
                                </div>
                            </Col>
                        )}
                    </Row>
                </>) : null}
        </div>
    )
}

export default ViewEditProfile
